/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_lost_in_tech_jargon_and_choices = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA, no-code, cloud, APIs... Vous êtes perdu dans le jargon tech et les choix possibles.`)
};

const en_lost_in_tech_jargon_and_choices = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI, no-code, cloud, APIs... You're lost in tech jargon and endless choices.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const lost_in_tech_jargon_and_choices = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.lost_in_tech_jargon_and_choices(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("lost_in_tech_jargon_and_choices", locale)
	if (locale === "fr") return fr_lost_in_tech_jargon_and_choices(inputs)
	return en_lost_in_tech_jargon_and_choices(inputs)
};